import { Table, Tooltip } from "antd";
import { useContext, useEffect, useState } from "react";

import { ExportToExcel } from "../../utils/exportExcel";

import { useQuery } from "@tanstack/react-query";
import Something from "../../components/shared/Something";
import Moment from "react-moment";
import { Link, useNavigate } from "react-router-dom";
import { ColumnsType } from "antd/es/table";
import { AuthContext } from "../../contexts/AuthContext";
import {
  DeleteOutlined,
  FileExcelOutlined,
  ReloadOutlined,
  EditOutlined,
} from "@ant-design/icons";
import {
  handleEntriesTopBranches,
  handleExportEntries,
  handleFetchAllEntries,
  handleFetchEntries,
} from "../../api/entries";
import moment from "moment";
import DeleteEntry from "./components/DeleteEntry";
import HomeHeader from "../home/components/HomeHeader";

export default function Entries({ status }: any) {
  const { user } = useContext(AuthContext);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [isExporting, setExporting] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>(null);
  const access = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  const deleteAccess = [9];

  const initials = {
    branch: 0,
    startDate: moment().startOf("month"),
    endDate: moment().endOf("month"),
  };
  const [filters, setFilters] = useState<any>({ ...initials });

  const params = `branch=${filters?.branch}&startDate=${filters?.startDate}&endDate=${filters?.endDate}`;

  const { data: branches } = useQuery({
    queryKey: ["branches", params],
    queryFn: () => handleEntriesTopBranches({ params }),
  });

  const clearFilters = () => {
    setFilters({ ...initials });
  };

  const navigate = useNavigate();

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 24,
    total: 0,
  });

  const {
    data: entries,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["entries", pagination.page, pagination.limit, params],
    queryFn: () =>
      handleFetchEntries({
        page: pagination.page,
        limit: pagination.limit,
        status: status || "",
        params,
      }),
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }
  const getColumns = (user: any, access: any) => {
    const columns: ColumnsType<DataType> = [
      {
        title: "S/N",
        width: 40,
        render: (record: any, text: any, index: any) => (
          <span className="text-gray-700 ml-2">
            {pagination?.page * pagination?.limit -
              pagination?.limit +
              index +
              1}
          </span>
        ),
        fixed: "left",
      },
      {
        title: "DATE",
        width: 100,
        render: (record: any) => (
          <span className="text-gray-700">
            <Moment format="DD/MM/YYYY">{record?.createdAt}</Moment>
          </span>
        ),
      },
      {
        title: "CUSTOMER",
        width: 280,
        render: (record: any) => {
          return (
            <div className="text-black capitalize truncate">
              {record?.name || "-"}
            </div>
          );
        },
      },
      {
        title: "LOCATION",
        width: 290,
        render: (record: any) => {
          return (
            <div className="text-black capitalize">
              {record?.ward}, {record?.district}, {record?.region}
            </div>
          );
        },
      },
      {
        title: "GENDER",
        width: 100,
        render: (record: any) => {
          return (
            <div className="text-black capitalize">{record?.gender || "-"}</div>
          );
        },
      },
      {
        title: "BRANCH",
        width: 100,
        render: (record: any) => {
          return <div className="text-black">{record?.branch}</div>;
        },
      },
      {
        title: "MOBILE",
        width: 180,
        render: (record: any) => {
          return <div className="text-black">{record?.mobile || "-"}</div>;
        },
      },
      {
        title: "VEHICLE",
        width: 120,
        render: (record: any) => {
          return (
            <div className="text-gray-700">
              <div className="">{record?.registration}</div>
            </div>
          );
        },
      },
      {
        title: "MAKE",
        width: 300,
        render: (record: any) => (
          <span className="text-gray-700">{record?.make}</span>
        ),
      },
      {
        title: "MODEL",
        width: 300,
        render: (record: any) => (
          <div className="text-gray-700 truncate">{record?.model}</div>
        ),
      },
      {
        title: "YEAR",
        width: 100,
        render: (record: any) => (
          <span className="text-gray-700">{record?.year}</span>
        ),
      },
      {
        title: "MILEAGE",
        width: 100,
        render: (record: any) => (
          <span className="text-gray-700">{record?.mileage}</span>
        ),
      },
      {
        title: "CREATED AT",
        width: 140,
        render: (record: any) => (
          <span className="text-gray-700">
            <Moment fromNow>{record?.createdAt}</Moment>
          </span>
        ),
      },
      {
        title: "ACTIONS",
        width: 80,
        align: "center",
        fixed: "right",
        render: (record: any) => (
          <div className="flex justify-center">
            <button
              onClick={() => {
                setSelected(record);
                navigate(`/entries/${record?._id}/update`);
              }}
              className="border  py-1 px-2 mx-1 flex items-center bg-yellow-50 text-yellow-800 shadow-sm"
            >
              <EditOutlined />
            </button>
            <button
              onClick={() => {
                setSelected(record);
                setDeleteModal(true);
              }}
              className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm"
            >
              <DeleteOutlined />
            </button>
          </div>
        ),
      },
    ];
    return columns.filter((column: any) => {
      if (column.title === "ACTIONS") {
        return deleteAccess.includes(user?.accessLevel);
      }
      return true;
    });
  };
  const columns = getColumns(user, access);

  const exportRequests = async () => {
    setExporting(true);
    const res = await handleExportEntries();
    ExportToExcel(
      res.records?.map((item: any, index: number) => {
        return {
          "S/N": index + 1,
          Date: item?.createdAt
            ? moment(item.createdAt).format("DD/MM/YYYY")
            : "N/A",
          Name: item?.name || "-",
          Gender: item?.gender || "-",
          Branch: item?.branch || "-",
          Mobile: item?.mobile || "-",
          Region: item?.region || "-",
          District: item?.district || "-",
          Ward: item?.ward || "-",
          "Service Type": item?.serviceType || "-",
          "Product Types": item?.serviceType || "-",
          Registration: item?.registration || "-",
          Make: item?.make || "-",
          Model: item?.model || "-",
          Mileage: item?.mileage || "-",
          "Manf. Year": item?.year || "-",
        };
      }),
      "Entries.xlsx"
    );
    setExporting(false);
  };

  useEffect(() => {
    setPagination({ ...pagination, total: entries?.total });
  }, [entries]);

  return (
    <div className="bg-gray-100">
      <div className="bg-white m-1">
        <HomeHeader
          title={"All Entries"}
          subtitle={"Manage all open entries."}
          clearFilters={clearFilters}
          setFilters={setFilters}
          filters={filters}
          branches={branches}
          actions={
            <div className="flex">
              <Tooltip title="Export To Excel">
                <button
                  className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100 shadow-sm"
                  onClick={() => exportRequests()}
                >
                  {isExporting ? (
                    <ReloadOutlined />
                  ) : (
                    <FileExcelOutlined size={20} />
                  )}
                </button>
              </Tooltip>
              {access?.includes(user?.accessLevel) && (
                <Link
                  to={"/entries/new"}
                  className="flex mx-2 justify-center items-center border px-4 h-8  bg-karimjee  hover:bg-karimjee-dark text-white shadow-sm"
                >
                  + New
                </Link>
              )}
            </div>
          }
        />

        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="border p-2 shadow-sm">
            <Table
              size="small"
              dataSource={entries?.records}
              columns={columns}
              scroll={{ y: 700, x: "max-content" }}
              rowKey="id"
              bordered
              pagination={{
                current: pagination?.page,
                pageSize: pagination?.limit,
                total: pagination?.total,
              }}
              rowClassName={"hover:bg-gray-100 cursor-pointer"}
              onChange={(e: any) => handlePageChange(e)}
              loading={isLoading}
            />
          </div>
        )}
      </div>

      <DeleteEntry
        isVisible={deleteModal}
        setVisible={setDeleteModal}
        selected={selected}
      />
    </div>
  );
}
